import { create } from "zustand";
import { persist } from "zustand/middleware";
import { ThemeMode, themes, ColorScheme } from "./colors";
import { ENABLE_THEMING } from "../constants";

interface ThemeStore {
  theme: ThemeMode;
  colors: ColorScheme;
  setTheme: (theme: ThemeMode) => void;
  toggleTheme: () => void;
}

const getSystemTheme = (): ThemeMode => {
  if (!ENABLE_THEMING) {
    return "light";
  }
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "light";
};

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: getSystemTheme(),
      colors: themes[getSystemTheme()],
      setTheme: (newTheme: ThemeMode) => {
        const newColors = themes[newTheme];

        const root = document.documentElement;
        Object.entries(newColors).forEach(([key, value]) => {
          root.style.setProperty(`--color-${key}`, value);
        });

        root.className = newTheme;

        set({ theme: newTheme, colors: newColors });
      },
      toggleTheme: () => {
        const currentTheme = get().theme;
        const newTheme = currentTheme === "light" ? "dark" : "light";
        get().setTheme(newTheme);
      },
    }),
    {
      name: "theme-storage",
      onRehydrateStorage: () => (state) => {
        if (state) {
          const root = document.documentElement;
          Object.entries(state.colors).forEach(([key, value]) => {
            root.style.setProperty(`--color-${key}`, value);
          });
          root.className = state.theme;
        }
      },
    },
  ),
);
